import { Fragment } from "react";
import { Listbox, Transition } from "@headlessui/react";
import { FiCheck, FiChevronDown } from "react-icons/fi";

export default function DarkSelect({
	value,
	onChange,
	options,
	disabled = false,
	size = "md", // md | sm
	className = "",
}) {
	const sizeClasses =
		size === "sm"
			? "py-1 pl-3 pr-8 text-sm"
			: "py-2 pl-4 pr-10 text-sm";

	return (
		<Listbox value={value} onChange={onChange} disabled={disabled}>
			<div className={`relative ${className}`}>
				<Listbox.Button
					className={`relative w-full cursor-pointer rounded-lg bg-white/10 border border-white/20 text-left text-white focus:outline-none focus:ring-2 focus:ring-blue-500 backdrop-blur-lg transition-all
          ${sizeClasses}
          ${disabled ? "opacity-50 cursor-not-allowed" : ""}
          `}
				>
					<span className="block truncate">
						{options.find(o => o.value === value)?.label}
					</span>

					<span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2 text-gray-400">
						<FiChevronDown size={16} />
					</span>
				</Listbox.Button>

				<Transition
					as={Fragment}
					enter="transition ease-out duration-100"
					enterFrom="opacity-0 scale-95"
					enterTo="opacity-100 scale-100"
					leave="transition ease-in duration-75"
					leaveFrom="opacity-100 scale-100"
					leaveTo="opacity-0 scale-95"
				>
					<Listbox.Options className="absolute z-50 mt-2 max-h-60 w-full overflow-auto rounded-xl bg-gray-900/95 backdrop-blur-xl border border-white/10 shadow-2xl focus:outline-none">
						{options.map((option) => (
							<Listbox.Option
								key={option.value}
								value={option.value}
								className={({ active }) =>
									`relative cursor-pointer select-none py-2 pl-9 pr-4 text-sm ${active ? "bg-blue-600 text-white" : "text-gray-200"
									}`
								}
							>
								{({ selected }) => (
									<>
										<span className={`block truncate ${selected ? "font-semibold" : ""}`}>
											{option.label}
										</span>
										{selected && (
											<span className="absolute inset-y-0 left-0 flex items-center pl-3 text-blue-400">
												<FiCheck size={14} />
											</span>
										)}
									</>
								)}
							</Listbox.Option>
						))}
					</Listbox.Options>
				</Transition>
			</div>
		</Listbox>
	);
}


